//  Core JS files -->
import "./importers/jquery";
import "../../vendor/assets/javascripts/limitless_kit/core/libraries/bootstrap.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/loaders/blockui.min";
import "./importers/limitless/datatable";
import {} from "../../vendor/assets/javascripts/jquery-ujs";
import "./importers/clipboard";
import "../../vendor/assets/javascripts/intlTelInput/core.min";
import "../../vendor/assets/javascripts/intlTelInput/utils";
import "../../vendor/assets/javascripts/graam";
import "../../vendor/assets/javascripts/aircall";
//  /core JS files -->


//  Theme JS files -->
import "./importers/limitless/switchery";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/styling/uniform.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/selects/bootstrap_multiselect";
import "./importers/limitless/autosize";
import "./importers/limitless/moment";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/daterangepicker";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/pickadate/picker";
import "../../vendor/assets/javascripts/limitless_kit/plugins/pickers/pickadate/picker.time";
import "../../vendor/assets/javascripts/limitless_kit/plugins/ui/nicescroll.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/selects/select2.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/tags/tagsinput.min";
import "./importers/pnotify";
import "../../vendor/assets/javascripts/pnotify/pnotify.buttons";
import "../../vendor/assets/javascripts/pnotify/pnotify.nonblock";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/validation/validate.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/forms/validation/localization/messages_fr.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/media/fancybox.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/ui/prism.min";
import "../../vendor/assets/javascripts/limitless_kit/plugins/sliders/ion_rangeslider.min";

import "../../vendor/assets/javascripts/limitless_kit/core/app";
//  /theme JS files -->


//  Lang files -->
import "./lang/date_range_picker/fr";
//  /Lang files -->


//  Commons files -->
import "./commons/utils";
import "./commons/uploader";
import "./commons/date_range_picker";
import "./commons/modal";
import "./commons/search_filter";
import "./commons/image_modal_opener";
import "./commons/containers_toggler";
import "./commons/form_autosave";
import "./commons/color_previewer";
import "./commons/value_switcher";
import "./commons/ckeditor_inline_module";
import "./commons/trigger_native_event";
import "./commons/password_toggler";
import "./commons/emoji_picker";
//  /Commons files -->


//  Specific files -->
import "./backoffice/layout";
import "./backoffice/loader";
import "./backoffice/datatables";
import "./backoffice/selects";
import "./backoffice/forms";
import "./backoffice/dropdowns";
import "./backoffice/tabs";
import "./backoffice/screenshot_updater";
import "./backoffice/attached_files_uploader";
import "./backoffice/global_search";
import "./backoffice/notifications";
import "./backoffice/comments";
import "./backoffice/contacts";
import "./backoffice/daterangepicker";
import "./backoffice/decryption";
import "./backoffice/form_validator";
import "./backoffice/call_center";
import "./backoffice/twilio_services";
import "./backoffice/ace_editor";
import "./backoffice/backoffice";
import "./backoffice/email_model_previewer";
import "./backoffice/website_migration_statuses_updater";
import "./backoffice/multiple_checkbox";
import "./backoffice/unsubscription_requests_form";
import "./backoffice/buttons";
import "./backoffice/spams";
import "./backoffice/phone_call_qualification";
import "./backoffice/local_management/migration/actusite_action_cable";
import "./backoffice/social/migration/actusite_action_cable";
import "./backoffice/emailing/migration/actusite_action_cable";
import "./backoffice/contact_qualification";
import "./backoffice/customer_pulse";
import "./backoffice/form_submit_ajax";
import "./backoffice/integrations/voip/aircall";
import "./backoffice/integrations/voip/graam";
import "./stimulus/backoffice";
//  /Specific files -->


//  Modal files -->
import "./backoffice/modals/modal_main";
import "./backoffice/modals/modal_create_reminder";
import "./backoffice/modals/modal_edit_reminder";
import "./backoffice/modals/modal_create_comment";
import "./backoffice/modals/modal_edit_comment";
import "./backoffice/modals/modal_related_comments";
import "./backoffice/modals/modal_create_registrar";
import "./backoffice/modals/modal_communication_center";
import "./backoffice/modals/modal_delete_domain_request";
import "./backoffice/modals/modal_service_deal_manage_discount_vouchers";
import "./backoffice/modals/modal_create_contact";
import "./backoffice/modals/modal_create_customer_need_detection";
import "./backoffice/modals/modal_customer_need_detection_lost_confirmation";
import "./backoffice/modals/modal_create_specific_deal_item";
import "./backoffice/modals/modal_white_spaces_document";
import "./backoffice/modals/modal_filters";
import "./backoffice/modals/modal_record_column_history";
//  /Modal files -->
